<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B9xUDq/tc-custom/9781683352976.jpg?1737919186737" alt="This image is the cover for the book Craft a Life You Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Craft a Life You Love
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn how to focus your creative energy to make things—and make things happen. </b><br/><br/>In this blend of memoir and hardworking handbook, creativity and craft maven Amy Tangerine shows how to find your flow, maintain a positive mindset, and cultivate a rich and fulfilling life by focusing on what truly matters and implementing small yet powerful changes. <br/><br/>Chapters explore how to craft the soul, craft the right mindset, craft the right environment, craft good habits, rediscover your creative mojo, and maintain momentum, with each section offering exercises for taking your creative practice to the next level. For anyone who has felt disconnected from their creativity or has had trouble saving a space for their passions, <i>Craft a Life You Love</i> will teach you how to make time for creativity each and every day.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Tangerine
      </h2>
      
      <p class="authorDescription body article">Amy Tangerine teaches creative workshops all over the world. She has partnered with companies including Disney, Facebook, Target, Sanrio, and more, and she has a scrapbook line with American Crafts. She teaches online at Craftsy and Brit + Co. You can see more of her work at amytangerine. com. She lives in Culver City, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ABRAMS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6cba5dfa